import React, { Fragment, useEffect, useRef, useState } from "react"
import MetaTags from 'react-meta-tags';

import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getSmsList, sendSms, getSmsTemplateList, getMyCompanyList } from "../../crud/alarm.crud"
import moment from 'moment';
import weaverOverlay from "../../assets/images/weaver_overlay.png"
import Util from "pages/Dashboard/Common/Util";
import Modal from "components/RopikCustom/Modal_v2";
import phone from "../../assets/images/SMS_phone.png"
import SelectBox from "components/RopikCustom/SelectBox";
import { getCollectZoneList } from "crud/search.crud";


const initSearchCondition = {
  companyName: '',
  startDate: '',
  sendDate: '',
  endDate: '', 
}

const initSmsSearchCondition = {
  companyName: '',
  companyNumber: '',
  collectZone: '',  
}

const SMSShippingManagement = () => {
  const tableRefs = useRef([]);

  const [inputItem, setInputItem] = useState({})
  const [modalShow, setModalShow] = useState({
    select: false,
  })
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [isSearch, setIsSearch] = useState(false);    
  const [isContentListEnd, setIsContentListEnd] = useState(false);    
  const [sendType, setSendType] = useState('individual')
  const [callerNumber, setCallerNumber] = useState('')
  const [receivingNumber, setReceivingNumber] = useState('')
  const [selectedReceivingNumber, setSelectedReceivingNumber] = useState('')
  const [contentList, setContentList] = useState([])
  const [receivingNumberList, setReceivingNumberList] = useState([])
  const [selectedItem, setSelectedItem] = useState([])  
  const [text, setText] = useState("");
  const [listCount, setListCount] = useState(0)
  const [contentListCount, setContentListCount] = useState(0)
  const [page, setPage] = useState(1)
  const [contentPage, setContentPage] = useState(1)
  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [smsSearchCondition, setSmsSearchCondition] = useState(initSmsSearchCondition)
  const [selectedCompany, setSelectedCompany] = useState([])
  const max = 200; // 최대 글자수  
  const [collectZoneData, setCollectZoneData] = useState([]);
  const [hoveredItem, setHoveredItem] = useState(null)
  const [explanationBoxStyle, setExplanationBoxStyle] = useState({})

  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;        
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;        
      if (scrollPosition >= scrollHeight - 1) {          
        setPage(page + 1)
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList, isLoading, isListEnd, page])


  useEffect(() => {
    const sccBody = document.getElementById("scc-body");
    if (!sccBody) return;
    const handleScroll = () => {
      const scrollPosition = sccBody.scrollTop;
      const scrollHeight = sccBody.scrollHeight - sccBody.clientHeight;
      if (scrollPosition >= scrollHeight - 1) {
        setContentPage(page + 1)
      }
    }
    sccBody.addEventListener('scroll', handleScroll)

    return () => {
      sccBody.removeEventListener('scroll', handleScroll)
    }
  }, [contentList, isLoading, isListEnd, page])

  const getCompanyData = async () => {
    try {
      const params = {      
        company_name : smsSearchCondition?.companyName || '',       
        company_number: smsSearchCondition?.companyNumber || '',       
        collect_zone: smsSearchCondition?.collectZone || '',       
      }

      const response = await getMyCompanyList(params);
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {                    
          setReceivingNumberList([...content])
        } else {
          setReceivingNumberList([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCollectZoneDataList = async () => {
    try {
      const response = await getCollectZoneList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCollectZoneData([...content])
        } else {
          setCollectZoneData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getContentList = async () => {
  
    if (isLoading || isContentListEnd) {
      return;
    }    
    
    setIsLoading(true)
    
    const params = {                
      page: contentPage,
    }

    const rs = await getSmsTemplateList(params)
    if (rs.data?.results) {
      setContentListCount(rs.data.count)
      const content = rs.data?.results        
      const new_list = [...contentList, ...content]
      setContentList(new_list)
      if (new_list.length >= rs.data.count) {
        setIsContentListEnd(true)
      }              
    }
    setIsLoading(false)
  }

  const getDataList = async () => {
  
    if (isLoading || isListEnd) {
      return;
    }    
    
    setIsLoading(true)
    
    const params = {      
      company_name : searchCondition?.companyName || '',       
      start_date: searchCondition?.sendDate ? moment(searchCondition?.sendDate, 'YYYY-MM-DD').format('YYYY-MM-DD'): '',
      end_date: searchCondition?.sendDate ? moment(searchCondition?.sendDate, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD') : '',               
      page: page,
    }

    const rs = await getSmsList(params)
    if (rs.data?.results) {
      setListCount(rs.data.count)
      const content = rs.data?.results        
      const new_list = [...dataList, ...content]
      setDataList(new_list)
      if (new_list.length >= rs.data.count) {
        setIsListEnd(true)
      }        
    }
    setIsLoading(false)
  }

  const checkList = (item) => {
    if (selectedItem.filter(itm => itm.id == item.id).length > 0 ){
      setSelectedItem(selectedItem.filter(itm=> itm.id !== item.id))
      setSelectedReceivingNumber(selectedItem.filter(itm=> itm.id !== item.id).map(i => Util.handleMobileNumberChange(i.mobile_phone)).join(", "))      
    }else{      
      setSelectedItem([...selectedItem, item])
      setSelectedReceivingNumber([...selectedItem, item].map(i => Util.handleMobileNumberChange(i.mobile_phone)).join(", "))      
    }        
  }
  
  const checkAll = () => {    
    if (selectedItem.length === receivingNumberList.length) {
      setSelectedItem([])
      setSelectedReceivingNumber('')
    } else {      
      setSelectedItem(receivingNumberList)            
      setSelectedReceivingNumber(receivingNumberList.map(i => Util.handleMobileNumberChange(i.mobile_phone)).join(", "))      
    }
  }


  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
  }

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({ ...prev, [key]: value }))
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const changeSmsSearchCondition = (key, value) => {
    setSmsSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  useEffect(()=>{
    getCollectZoneDataList()
  },[])

  useEffect(() => {    
    getDataList()    
  }, [page])

  useEffect(() => {
    if(isSearch){      
      getDataList()
      setIsSearch(false)
    }
  },[isSearch])

  useEffect(()=>{
    getContentList()
  }, [contentPage])

  const sendSmsData = async () => {    
    let receiveData = []

    if ( sendType === 'individual'){
      const item = {
        recive_number : receivingNumber,
        company_to_id : null,
      }
      receiveData.push(item)        
    }else{
      for(let i=0; i<selectedCompany.length; i++){
        const item = {
          recive_number : selectedCompany[i]?.mobile_phone,
          company_to_id : selectedCompany[i]?.company,
        }
        receiveData.push(item)
      }      
    }            
    const params = {
      receive_data: JSON.stringify(receiveData),
      send_number: callerNumber,
      send_type : sendType,
      subject : '',
      content : text

    }
    const rs = await sendSms(params)
    if (rs.data?.code == '0000') {
      alert('정상적으로 발송했습니다.')
      setDataList([])                              
      setIsListEnd(false)
      setIsLoading(false)
      if (page != 1){
        setPage(1)     
      }else{
        onSearch()
      }   
    }
  }

  const onSearch = async () => {
    setIsSearch(true)
  }

  const handleMouseEnter = (item, index) => {
    const rect = tableRefs.current[index].getBoundingClientRect();
    console.log("top:", rect.top);
    console.log("left:", rect.left);
    console.log("width:", rect.width);
    console.log("height:", rect.height);

    setHoveredItem(item)
    setExplanationBoxStyle({
      top: rect.top + 40,
      left: rect.left + (rect.width / 2)
    })
  }

  const handleMouseLeave = () => {
    setHoveredItem(null)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>SMS 발송 관리 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" title="메시지 관리" breadcrumbItem="SMS 발송 관리" />

          <div className="d-flex">
            <div 
              className="margin-right-30" 
              style={{
                backgroundImage: `url(${phone})`,
                backgroundSize: 'cover',      // div 크기에 맞게 채우기
                backgroundPosition: 'center', // 가운데 정렬
                width: '407px',               // div 너비 지정
                height: '797px',
                padding: "72px 20px", // 내부 여백
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",                
              }}
            >
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                maxLength={max}
                placeholder="메시지를 입력하세요…"
                style={{
                  flex: 1,
                  width: "100%",
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid rgba(0,0,0,0.2)",
                  resize: "none",
                  fontSize: "14px",
                  lineHeight: 1.5,
                  background: "rgba(255,255,255,0.85)", // 배경에 가려지지 않게
                }}
              />
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  textAlign: "right",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                {text.length} / {max}
              </div>
            </div>
            <div className="flex-1">
              <Row>
                <Col xl={4} lg={12}>
                  <div style={{ height: 797 }} className="d-flex flex-direction-column justify-content-between">
                    <div>
                      <p className="font-weight-bold font-size-15 mb-2">SMS 발송</p>
                      <Card className="mb-0">
                        <CardBody className="padding-0">
                          <table className="input-table">
                            <tbody>
                              <tr>
                                <td className="w-35 padding-left-8 primary-bg white-text">발송대상</td>
                                <td className="w-65">
                                  <select className='waver-select-box w-100 border-radius-0' value={sendType} onChange={(e) => {
                                    setSendType(e.target.value)
                                  }}>
                                    <option value="individual">{'개별 발송'}</option>
                                    <option value="group">{'다량 발송'}</option>
                                  </select>
                                </td>
                              </tr>
                              <tr>
                                <td className="w-10 padding-left-8 primary-bg white-text">발신번호</td>
                                <td className="w-15">
                                  <input className='waver-input-box w-100 border-radius-0' value={callerNumber} placeholder="발신번호" onChange={(e) => { setCallerNumber(e.target.value) }} />
                                </td>
                              </tr>
                              {sendType === 'individual' &&
                                <tr>
                                  <td className="w-10 padding-left-8 primary-bg white-text">수신번호</td>
                                  <td className="w-15">
                                    <input className='waver-input-box w-100 border-radius-0' value={receivingNumber} placeholder="수신번호" onChange={(e) => { setReceivingNumber(e.target.value) }} />
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </CardBody>
                      </Card>
                      {sendType === 'group' &&
                        <Fragment>
                          <button style={{ height: 40 }} type="button" className="margin-top-12 w-100 custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 secondary-bg white-text border-none" onClick={() => {
                            getCompanyData()
                            modalOpen('select')
                          }}>
                            번호 선택
                          </button>
                          <div style={{ height: 30 }} className="margin-top-12 w-100 custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 primary-bg white-text border-none text-center">
                            선택된 번호(최대 50개)
                          </div>
                          <div style={{ height: 150, border: '1px solid #D9D9D9' }} className="w-100 padding-6">
                            <textarea className="w-100 h-100" disabled value={selectedCompany.map(i => Util.handleMobileNumberChange(i.mobile_phone)).join(", ")} />
                          </div>
                        </Fragment>
                      }
                    </div>
                    <div>
                      <p className="font-weight-bold font-size-15 mb-2">SMS 발송 내용 선택</p>
                      <Card className="mb-0">
                        <CardBody className="padding-0">
                          <div className="table-responsive" id={"scc-body"} style={{maxHeight: 300}}>
                            <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                              <thead className="chart-thead">
                                <tr>
                                  <th scope="col">No</th>
                                  <th scope="col">발송 제목</th>
                                </tr>
                              </thead>
                              <tbody className="chart-tbody">
                                {contentList.map((item, index) => {
                                  return (
                                    <tr className="pointer" key={item.id + '_' + index} onClick={()=>{
                                      setText(item.content)
                                    }}>
                                      <td>{contentListCount - index}</td>
                                      <td>{item.subject}</td>
                                    </tr>
                                  )
                                })}
                                {contentList.length === 0 &&
                                  <tr>
                                    <td scope="row" colSpan="14">데이터가 없습니다.</td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </CardBody>
                      </Card>
                      <button 
                        style={{ height: 40 }} 
                        onClick={()=>{
                          sendSmsData()
                        }}
                        type="button" 
                        className="margin-top-12 w-100 custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 secondary-bg white-text border-none">
                        메시지 발송
                      </button>
                    </div>
                  </div>
                </Col>
                <Col xl={8} lg={12}>
                  <p className="font-weight-bold font-size-15 mb-2">SMS 가능 수량 : <span className="font-size-18">{ }</span> </p>
                  <div className="d-flex w-100 gap-30 align-items-center">
                    <div className="email-rightbar flex-grow-1">
                      <Card className="mb-0">
                        <CardBody className="padding-0">
                          <table className="input-table">
                            <tbody>
                              <tr>
                                <td className="w-10 padding-left-8 primary-bg white-text">사업장명(상호2)</td>
                                <td className="w-15">
                                  <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={searchCondition.companyName} onChange={(e) => {
                                    changeSearchCondition('companyName', e.target.value)
                                  }} />
                                </td>
                                {/* <td className="w-10 padding-left-8 primary-bg white-text">발송일자 검색</td>
                                <td className="w-15">
                                   <input className="waver-input-box w-100 border-radius-0" type="date" value={searchCondition.sendDate} onChange={(e) => {
                                    changeSearchCondition('sendDate', e.target.value);
                                  }} />
                                </td> */}
                              </tr>
                            </tbody>
                          </table>
                        </CardBody>
                      </Card>
                    </div>
                    <div className="d-flex flex-direction-column align-items-end">
                      <button type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none margin-right-0" onClick={() => {                        
                        setDataList([])                              
                        setIsListEnd(false)
                        setIsLoading(false)
                        if (page != 1){
                          setPage(1)     
                        }else{
                          onSearch()
                        }                        
                      }}>
                        검색
                      </button>
                    </div>
                  </div>
                  <p className="font-size-15 mb-2 margin-top-20"><span className="font-weight-bold">SMS 발송 목록</span> [ 건수 : {listCount} 건 ]</p>
                  <Card className="mb-0">
                    <CardBody className="padding-0">
                      <div className="table-responsive" id={"sc-body"} style={{maxHeight: 660}}>
                        <table className="table table-hover table-centered table-nowrap mb-0 chart-table" >
                          <thead className="chart-thead">
                            <tr>
                              <th scope="col">발송일시</th>
                              <th scope="col">상호</th>
                              <th scope="col">수신번호</th>
                              <th scope="col">메시지 내용</th>
                            </tr>
                          </thead>
                          <tbody className="chart-tbody">
                            {dataList.map((item, index) => {
                              return (
                                <tr>
                                  <td>{moment(item.created_at).format('YYYY-MM-DD HH:mm')}</td>
                                  <td>{item.company_name}</td>
                                  <td>{Util.handleMobileNumberChange(item.receive_number)}</td>
                                  <td
                                    ref={(el) => (tableRefs.current[index] = el)}
                                    key={item.id + '_' + index}
                                    onMouseEnter={() => {handleMouseEnter(item, index)}}
                                    onMouseLeave={handleMouseLeave}
                                  >{Util.truncateString(item.content, 20)}</td>
                                </tr>
                              )
                            })}
                            {dataList.length === 0 &&
                              <tr>
                                <td scope="row" colSpan="14">데이터가 없습니다.</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>

        </Container>
      </div>

      <Modal
        title={'수신번호 검색'}
        show={modalShow.select}
        onHide={() => {
          modalClose('select')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">사업장명</td>
                  <td className="w-35">
                    <input className='waver-input-box w-100 border-radius-0' placeholder="사업장명을 입력해주세요" value={smsSearchCondition.companyName} onChange={(e) => {
                      changeSmsSearchCondition('companyName', e.target.value)
                    }}/>
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">사업자번호</td>
                  <td className="w-35">
                    <input className='waver-input-box w-100 border-radius-0' placeholder="사업자 번호를 입력해주세요" value={smsSearchCondition.companyNumber} onChange={(e) => {
                      changeSmsSearchCondition('companyNumber', e.target.value)
                    }} />
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">수거구역</td>
                  <td className="w-35">
                     <SelectBox
                        value={smsSearchCondition.collectZone}
                        onChange={changeSmsSearchCondition}
                        options={collectZoneData}
                        keyValue={'collectZone'}
                      />                    
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12"></td>
                  <td className="w-35"></td>
                </tr>
              </tbody>
            </table>
            <div className="d-flex w-100 justify-content-end margin-top-8">
              <button style={{width: 142}} type="button" className="custom-btn border-radius-0 dark-bg white-text button-border margin-right-0" onClick={() => {
                getCompanyData()
              }}>
                검색
              </button>
            </div>
            <p className="font-size-13 font-weight-bold margin-top-10 margin-bottom-4">수신번호 선택</p>
            <div className="table-responsive">
              <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                <thead className="chart-thead">
                  <tr>
                    <th scope="col"><input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom" checked={selectedItem.length === receivingNumberList.length} value={""} type="checkbox" onChange={() => {
                      checkAll()
                    }} /></th>
                    <th scope="col">상호</th>
                    <th scope="col">사업자번호</th>
                    <th scope="col">수거구역</th>
                  </tr>
                </thead>
                <tbody className="chart-tbody">
                  {receivingNumberList.map((item, index) => {                    
                    return (
                      <tr key={'collection_settlement_edit_'+index}>
                        <td><input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom pointer" type="checkbox" checked={selectedItem.filter(itm => itm.id == item.id).length > 0} value={item.id} onChange={() => {
                          checkList(item)
                        }}/></td>
                        <td>{item.company_name}</td>
                        <td>{Util.checkBusinessNumber(item.company_number)}</td>
                        <td>{item.collect_zone_name}</td>
                      </tr>
                    )
                  })}
                  {receivingNumberList.length === 0 &&
                    <tr>
                      <td scope="row" colSpan="14">데이터가 없습니다.</td>
                    </tr>
                  }

                </tbody>
              </table>
            </div>
            <p className="font-size-13 font-weight-bold margin-top-10 margin-bottom-4">선택된 번호</p>
            <div style={{ height: 30 }} className="w-100 custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 primary-bg white-text border-none text-center">
              선택된 번호(최대 50개)
            </div>
            <div style={{ height: 150, border: '1px solid #D9D9D9' }} className="w-100 padding-6">
              <textarea
                className="w-100 h-100"
                disabled
                value={selectedReceivingNumber}
                style={{
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                  wordBreak: "keep-all"
                }}
              />
            </div>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex">
            <button style={{width: 112, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {              
              setSelectedCompany([...selectedItem])
              setSelectedItem([])
              setSelectedReceivingNumber([])
              modalClose('select')
            }}>수신번호 선택 완료</button>
            <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {              
              setSelectedItem([])
              setSelectedReceivingNumber([])
              modalClose('select')
            }}>취소</button>
          </div>
        }
      >
      </Modal>

      {hoveredItem &&
        <ExplanationBox text={hoveredItem.content} style={explanationBoxStyle} />
      }
    </React.Fragment>
  )
}

const ExplanationBox = (props) => {
  const { text, style } = props

  return (
    <Fragment>
      <div className="top-triangle" style={{top: style.top, left: style.left - 10}}>
        <div />
      </div>
      <div className="explanation-box" style={{ top: style.top + 20, left: style.left - (297 / 2), width: 297 }}>
        <p className="font-size-11 margin-bottom-0 padding-left-8 padding-right-8 padding-top-5 line-height-150 padding-bottom-14 pre-line">
          {text}
        </p>
      </div>
    </Fragment>
  )
}

export default SMSShippingManagement
